import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHero({ title, subtitle, crumb }) {
  return (
    <section className="relative bg-gradient-to-r from-teal-700 to-teal-600 overflow-hidden">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 15% 20%, rgba(255,255,255,0.25), transparent 35%), radial-gradient(circle at 85% 80%, rgba(255,255,255,0.15), transparent 35%)" }} />
      <div className="relative max-w-7xl mx-auto px-4 py-14 lg:py-20 text-center text-white">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold">{title}</h1>
        {subtitle && <p className="mt-3 max-w-2xl mx-auto text-teal-100 text-base sm:text-lg leading-relaxed">{subtitle}</p>}
        <nav className="mt-5 flex items-center justify-center gap-1.5 text-sm text-teal-100">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <ChevronRight className="w-4 h-4" />
          <span className="text-white font-medium">{crumb || title}</span>
        </nav>
      </div>
    </section>
  );
}
